var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPropertyAge = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 37,
  height: 37,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#6E3037",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M1 8.469h34.594M26.055 3.527H10.566M30.024 3.527h3.452c1.17 0 2.118.949 2.118 2.119v27.533c0 1.17-.949 2.118-2.118 2.118H3.118A2.12 2.12 0 0 1 1 33.18V5.645c0-1.17.949-2.119 2.118-2.119h3.867"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFCAA1",
  d: "M5.56 6.349v-3.39c0-.79.308-1.533.867-2.092A2.94 2.94 0 0 1 8.52 0a2.96 2.96 0 0 1 2.959 2.96v3.389zM25.115 6.349v-3.39c0-.79.308-1.533.867-2.092A2.94 2.94 0 0 1 28.074 0a2.963 2.963 0 0 1 2.96 2.96v3.389z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#6E3037",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M30.652 31.767v-8.763M21.475 31.767v-8.763M20.063 24.002l6-4.236 6.001 4.236"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFCAA1",
  d: "M27.829 26.824h-3.53v4.942h3.53z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#6E3037",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M20.063 31.766h12.002"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFCAA1",
  d: "M9.469 16.94v-5.643H3.827v5.642zM17.234 16.94v-5.643h-5.642v5.642zM9.469 32.47v-5.642H3.827v5.642zM17.234 32.47v-5.642h-5.642v5.642zM9.469 24.705v-5.642H3.827v5.642zM17.234 24.705v-5.642h-5.642v5.642zM25 16.94v-5.643h-5.642v5.642zM32.768 16.94v-5.643h-5.643v5.642z"
})));
export default SvgPropertyAge;